/**
 * Order Tracking — one stable iframe size (no dancing).
 * Page-content fit scripts may still run; CSS !important + --bb-ot-h wins.
 */
(function () {
  var PAD = 20;
  var RESERVE = 400; // reserved height before fit (prevents huge empty flash)
  var fitted = false;
  var passes = 0;

  function applySrcExtras(iframe) {
    if (iframe.dataset.bbOtSrcDone) return;
    iframe.dataset.bbOtSrcDone = '1';

    var urlParts = window.location.pathname.split('/');
    var orderId = urlParts[urlParts.length - 1];
    var lang = null;
    var src = iframe.getAttribute('src') || iframe.src;

    if (/^\/[a-zA-Z]{2}\/pages\//.test(window.location.pathname)) {
      lang = urlParts[1];
    }
    if (!lang) {
      var params = new URLSearchParams(window.location.search);
      var qLang = params.get('lang') || params.get('country');
      if (qLang && /^[a-zA-Z]{2}$/.test(qLang)) lang = qLang;
    }

    var next = src;
    if (/^[0-9]+$/.test(orderId) && next.indexOf('/' + orderId) === -1) {
      next += '/' + orderId;
    }
    if (lang && next.indexOf('lang=') === -1) {
      next += (next.indexOf('?') === -1 ? '?' : '&') + 'lang=' + lang;
    }
    if (next !== src) {
      iframe.src = next;
    }
  }

  function setHeight(iframe, px) {
    iframe.style.setProperty('--bb-ot-h', Math.round(px) + 'px');
  }

  function isLookup(doc) {
    return !!doc.querySelector('input[name="order_number"]');
  }

  function measure(doc, iframe) {
    if (isLookup(doc)) {
      var card =
        doc.querySelector('.max-w-md') ||
        doc.querySelector('.shadow-lg') ||
        doc.querySelector('main .border');
      if (!card) return 0;
      card.style.marginTop = PAD + 'px';
      card.style.marginBottom = PAD + 'px';
      return Math.ceil(card.getBoundingClientRect().height) + PAD * 2;
    }

    var main = doc.querySelector('main') || doc.body;
    var frameH = iframe ? iframe.clientHeight : 0;
    var top = main.getBoundingClientRect().top;
    var maxBottom = top;
    var nodes = main.querySelectorAll('div, section, ul, img, p, button, li');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var rect = node.getBoundingClientRect();
      if (rect.height < 8 || rect.width < 8) continue;
      var parent = node.parentElement;
      var shell = parent === main || parent === doc.body || node === main;
      if (shell && frameH && Math.abs(rect.height - frameH) < 16) continue;
      if (rect.bottom > maxBottom) maxBottom = rect.bottom;
    }
    return Math.ceil(maxBottom - top) + PAD;
  }

  function fit() {
    var iframe = document.getElementById('order-lookup-iframe');
    if (!iframe) return false;

    try {
      var doc = iframe.contentWindow && iframe.contentWindow.document;
      if (!doc || !doc.body) return false;

      if (!doc.getElementById('bb-ot-trim')) {
        var style = doc.createElement('style');
        style.id = 'bb-ot-trim';
        style.textContent = [
          'html, body { margin: 0 !important; padding: 0 !important; min-height: 0 !important; height: auto !important; background: transparent !important; }',
          'main, main > div { margin: 0 !important; padding: 0 !important; }',
          '.mt-12, .lg\\:mt-16, .xl\\:mt-20, .max-w-md { margin-top: 0 !important; margin-bottom: 0 !important; }'
        ].join('');
        doc.head.appendChild(style);
        void doc.body.offsetHeight;
      }

      var height = measure(doc, iframe);
      if (height < 200) return false;
      var current = parseFloat(iframe.style.getPropertyValue('--bb-ot-h')) || 0;
      if (passes > 0 && current && height < current - 8) height = current;

      if (height > 2800) height = 2800;
      setHeight(iframe, height);
      iframe.classList.add('bb-ot-ready');
      if (iframe.parentNode && iframe.parentNode.style) {
        iframe.parentNode.style.height = 'auto';
      }
      fitted = true;
      passes += 1;
      return true;
    } catch (e) {
      return false;
    }
  }

  function fitOnce() {
    if (fitted || passes > 2) return;
    if (fit()) return;
    requestAnimationFrame(function () {
      if (!fitted && passes < 2) fit();
    });
  }

  function bind() {
    var iframe = document.getElementById('order-lookup-iframe');
    if (!iframe) return;

    setHeight(iframe, RESERVE);
    applySrcExtras(iframe);

    iframe.addEventListener('load', function () {
      fitted = false;
      passes = 0;
      requestAnimationFrame(function () {
        requestAnimationFrame(fitOnce);
      });
      // one late pass for result images, then stop
      setTimeout(function () {
        fitted = false;
        if (passes < 2) fitOnce();
      }, 700);
    });

    try {
      if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
        requestAnimationFrame(fitOnce);
      }
    } catch (e) {}

    // safety: if load never fires, show reserved height rather than dancing forever
    setTimeout(function () {
      if (!fitted) {
        var el = document.getElementById('order-lookup-iframe');
        if (el) el.classList.add('bb-ot-ready');
      }
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
